export const ProfessionalWorkStatus = {
  RANKINGS: { value: "RANKINGS", label: "Rankings" },
  UPCOMING: { value: "UPCOMING", label: "All" },
  NEW_TO_WORKPLACE: { value: "NEW_TO_WORKPLACE", label: "New to your workplace" },
  IN_PROGRESS: { value: "IN_PROGRESS", label: "In Progress" },
  BLOCKED: { value: "BLOCKED", label: "Blocked" },
  PAST: { value: "PAST", label: "All" },
  STARRED: { value: "STARRED", label: "Starred" },
};

export const DefaultATeamRosterSize = 5;

export const DEFAULT_TOAST_AUTO_HIDE_DURATION_IN_MILLISECONDS = 8000;

export const A_TEAM_COLOR = "#1890FF";
